import { createSelector } from 'reselect';
import { getEwpDomainSelector } from './getDomainSelectors';

export const getUrlSelectors = createSelector(
  getEwpDomainSelector,
  (ewpDomain) => `${ewpDomain}/travel/v2/kyt/insights/hotels/inquiry_results`
);
